<template>
  <div
    class="safe-area-inset-bottom"
    :style="'background-color:' + backgroundColor"
  >
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "SafeAreaInsetBottomFixed",
  props: {
    backgroundColor: {
      type: String,
      default: "#FFF"
    }
  }
};
</script>

<style lang="scss" scoped>
.safe-area-inset-bottom {
  position: fixed;
  left: 0;
  width: 100%;
  bottom: 0;
  //屏幕安全区域适配
  .content {
    width: 100%;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>
